import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import WaterPumpDetail from '../../components/ac_central/WaterPumpDetail';
import { defaultRejectHandler } from '../../utils/utility';
import {
  getWaterPump,
  editWaterPump,
} from '../../redux/ac_central/water_pump_actions';

class WaterPumpEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.wpDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.wp !== nextProps.wp && nextProps.show) {
      this.props.getWaterPump(nextProps.wp.id);
    }
  }

  onSaveHandler() {
    const editedWP = this.wpDetail.getWrappedInstance().getWrappedInstance().getWPData();
    this.props.editWaterPump({
      ...editedWP,
      id: this.props.wp.id,
    });
  }

  render() {
    const { isEditing, errorMessage, wpDetail, t, getWaterPump, editWaterPump, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit water pump')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <WaterPumpDetail
            wp={wpDetail}
            ref={ref => (this.wpDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-water-pump-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.waterPump.errorMessage,
  isEditing: state.ac.waterPump.isEditing,
  wpDetail: props.wp && state.ac.waterPump.objects[props.wp.id],
});

const mapDispatchToProps = dispatch => ({
  editWaterPump: wp => defaultRejectHandler(dispatch(editWaterPump(wp.id, wp.name, wp.type, wp.power_required, wp.description, wp.image))),
  getWaterPump: id => defaultRejectHandler(dispatch(getWaterPump(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WaterPumpEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/WaterPumpEditModal.js